export default "__VITE_ASSET__DggePSIY__"